export const shouldRedirectToCanonicalIncident = (requestedIncidentId: string, canonicalIncidentId: string | undefined): boolean => {
  const requested = requestedIncidentId.trim();
  const canonical = canonicalIncidentId?.trim() ?? '';
  return requested !== '' && canonical !== '' && requested !== canonical;
};
